import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=48f1f8cf&scoped=true&"
import script from "./LogIn.vue?vue&type=script&lang=ts&"
export * from "./LogIn.vue?vue&type=script&lang=ts&"
import style0 from "./LogIn.vue?vue&type=style&index=0&id=48f1f8cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1f8cf",
  null
  
)

export default component.exports